export const cardTokens = {
  infoBackground: '#FBF6EE'
};

export const commonCardStyles = {
  cardBackground: {
    background: cardTokens.infoBackground
  },
  cardBackgroundColor: {
    backgroundColor: cardTokens.infoBackground
  },
  cardRadius4: {
    borderRadius: 4
  },
  cardRadius10: {
    borderRadius: '10px'
  },
  cardRadius20: {
    borderRadius: 20
  },
  cardRadius25: {
    borderRadius: '25px'
  }
};
